// Back-compat redirect for the retired full-page agent audit
// (/agents/runs/:runId/audit). The per-run detail now lives in the Copilot run
// history blade, so any old bookmark / link lands on the history page with a
// `?runId=` deep-link that auto-opens the blade for that run.

import { Navigate, useParams } from 'react-router-dom';

export function AuditRedirect() {
  const { runId } = useParams<{ runId: string }>();
  const to = runId ? `/ai-playground/history?runId=${encodeURIComponent(runId)}` : '/ai-playground/history';
  return <Navigate to={to} replace />;
}

export default AuditRedirect;
